import React, {useEffect, useState} from 'react';
import {Radio} from 'antd';
import {EventRegistrationType} from '../../../Util/commonUtility';
import './style.css';
import {useParams} from 'react-router-dom';
import useLocalization from '../../../Localization';

const EventTypeFilter = ({setEventType, isUsedForWaitingList = false}) => {
  const {registrationType} = useParams();
  const {ApplicationString} = useLocalization();
  const defaultEventType = registrationType || EventRegistrationType.regular;
  const [selectedEventType, setSelectedEventType] = useState(defaultEventType);

  const handleEventTypeChange = (e) => {
    const newEventType = e.target.value;
    setSelectedEventType(newEventType);
    setEventType(newEventType);
  };

  useEffect(() => {
    setEventType(defaultEventType);
    setSelectedEventType(defaultEventType); // Set default value from params or regular
  }, [registrationType, setEventType]);

  return (
    <Radio.Group
      prefixCls='user'
      className='event-type-tabs'
      onChange={handleEventTypeChange}
      value={selectedEventType} // Set the default selected value
    >
      <Radio.Button
        prefixCls='user'
        className='event-type-tab event-type-tab-regular'
        value={EventRegistrationType.regular}>
        {ApplicationString['eventTypeFilter.regularRegistration']}
      </Radio.Button>
      <Radio.Button
        prefixCls='user'
        className='event-type-tab event-type-tab-sponsorship'
        value={EventRegistrationType.sponsorship}>
        {ApplicationString['eventTypeFilter.sponsorshipRegistration']}
      </Radio.Button>
      {isUsedForWaitingList && (
        <Radio.Button
          prefixCls='user'
          className='event-type-tab event-type-tab-waiting-list'
          value={EventRegistrationType.waitingList}>
          {ApplicationString['eventTypeFilter.waitingListRegistration']}
        </Radio.Button>
      )}
    </Radio.Group>
  );
};

export default EventTypeFilter;
